import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import SectionHeaderLayout from "../../common/components/SectionHeaderLayout";
import RedirectionHandler from "../../common/handlers/RedirectionHandler";
import ToolItem from "./subComponent/ToolItem";
import { ToolsSectionContent } from "./types";
import { componentNameConstants } from "@repo/analytics/data-layer.constants";

const Tools = ({ content }: { content: ToolsSectionContent }) => {
  const { headerName, list } = content;
  const objValueList = Object.values(list);

  return (
    <SectionHeaderLayout header={headerName} >
      <div className={`flex flex-row gap-[16px] max-md:gap-[8px] max-md:flex-wrap`}>
        {
          objValueList?.map((el) => {
            return (<RedirectionHandler
              url={isOpenInApp() ? el.appdataurl : el.webdataurl} key={el?.cardTitle}
              cta_text={el?.cardTitle} section_title={componentNameConstants.TOOLS} isLoginRequired={el?.isLoginRequired ?? "false"}
            >
              <ToolItem url={isOpenInApp() ? el.mobileImage : el.desktopimage} title={el.cardTitle} />
            </RedirectionHandler>
            )
          })

        }
      </div>
    </SectionHeaderLayout>
  );
};

export default Tools;
